import React, { useContext } from 'react';

interface IPatientActivityContext {
  onActivity: () => void;
}

const PatientActivityContext = React.createContext<
  IPatientActivityContext | undefined
>(undefined);

export const usePatientActivity = () => {
  const context = useContext(PatientActivityContext);
  return context ?? { onActivity: () => {} };
};

export default PatientActivityContext;
